export const module = {
  info: {
    name: 'voip-rtp-finder',
    caption: 'rtp',
    viewGroup: 'status-and-report'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'RTP Finder',
    icon: 'el-icon-zoom-in',
    routeName: 'module->voip-rtp-finder->panel',
    children: [
      {
        caption: 'RTP List',
        icon: 'el-icon-view',
        routeName: 'module->voip-rtp-finder->panel->page',
        routeParams: { listPage: 1}
      },
      {
        caption: 'Similar View',
        icon: 'el-icon-document-copy',
        routeName: 'module->voip-rtp-finder->similar-view'
      }
    ]
  }
}

export default module
